import React from 'react'
import { useTranslation } from 'react-i18next'
import { H2, LayoutBand, Separator, Subheading, Row, Image, useTheme } from '@fs/zion-ui'
import { blackWavesJpg, errorMessageBotPng, whiteWavesJpg } from '../../images'

const ErrorFallback = () => {
  const [t] = useTranslation()
  const theme = useTheme()

  return (
    <LayoutBand
      image={theme === 'day' ? whiteWavesJpg : blackWavesJpg}
      style={{ backgroundPosition: 'center', backgroundSize: 'cover' }}
      marginY="lg"
    >
      <Row alignX="center">
        <Image src={errorMessageBotPng} alt="" aria-hidden="true" />
      </Row>
      <Separator size="xl" />
      <H2 centered size="H3">
        {t('video.error.heading', 'It looks like something went wrong')}
        <Separator size="xs" />
        <Subheading>
          {t(
            'generic.api.error.message',
            'We’re sorry, but there’s an issue loading the content. Please try again shortly while we investigate.'
          )}
        </Subheading>
      </H2>
    </LayoutBand>
  )
}

export default ErrorFallback
